var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBecomeAgentIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.2077 21.8743C45.2077 27.5123 40.6373 32.0827 34.9993 32.0827C29.3614 32.0827 24.791 27.5123 24.791 21.8743C24.791 16.2364 29.3614 11.666 34.9993 11.666C40.6373 11.666 45.2077 16.2364 45.2077 21.8743Z",
    fill: "#DC143C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 48.1243C52.5 53.7623 44.665 58.3327 35 58.3327C25.335 58.3327 17.5 53.7623 17.5 48.1243C17.5 42.4864 25.335 37.916 35 37.916C44.665 37.916 52.5 42.4864 52.5 48.1243Z",
    fill: "#DC143C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7733 14.584C21.2909 14.584 21.7962 14.6348 22.2841 14.7315C21.0954 16.8428 20.4173 19.28 20.4173 21.8757C20.4173 24.4081 21.0628 26.7897 22.1982 28.865C21.737 28.951 21.2606 28.996 20.7733 28.996C16.6479 28.996 13.3036 25.7698 13.3036 21.79C13.3036 17.8102 16.6479 14.584 20.7733 14.584Z",
    fill: "#DC143C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8887 55.3764C14.2323 53.3963 13.1257 50.9665 13.1257 48.1257C13.1257 45.3716 14.1657 43.004 15.7383 41.0578C10.183 41.4887 5.83398 44.5271 5.83398 48.2114C5.83398 51.9302 10.2595 54.991 15.8887 55.3764Z",
    fill: "#DC143C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5836 21.8757C49.5836 24.4081 48.9381 26.7897 47.8027 28.865C48.264 28.951 48.7404 28.996 49.2276 28.996C53.353 28.996 56.6973 25.7698 56.6973 21.79C56.6973 17.8102 53.353 14.584 49.2276 14.584C48.71 14.584 48.2047 14.6348 47.7168 14.7315C48.9055 16.8428 49.5836 19.28 49.5836 21.8757Z",
    fill: "#DC143C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1122 55.3764C59.7415 54.991 64.167 51.9302 64.167 48.2114C64.167 44.5271 59.8179 41.4887 54.2626 41.0578C55.8353 43.004 56.8753 45.3716 56.8753 48.1257C56.8753 50.9665 55.7686 53.3963 54.1122 55.3764Z",
    fill: "#DC143C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBecomeAgentIcon3);
export default __webpack_public_path__ + "static/media/become-agent-icon-3.1107e22c65dc952b5893a341084ca6ee.svg";
export { ForwardRef as ReactComponent };